import React, { memo } from 'react';

import classNames from 'classnames';
import moment from 'moment';

import { AlbumSelect } from '@features/AlbumSelect';
import { Icon, MultiSelect } from '@shared/ui';
import { OptionType } from '@shared/ui/MultiSelect';

import cls from '../ModalConstructionProgress.module.css';
import { useModalConstructionProgressBody } from './useModalConstructionProgressBody';
import { DateInput } from '../../../../../components/newUI/DateInput/DateInput';
import { TextArea } from '../../../../../components/newUI/TextArea/TextArea';

interface ModalConstructionProgressBodyProps {
    classes?: string;
    isEdit: boolean;
    formState: {
        date: string;
        description: string;
        albums: OptionType[];
    };
    onDate: (value: string) => void;
    onDescription: (name: string, value: string) => void;
    onAddNewAlbum?: (newTag: OptionType) => void;
    deleteSelectedAlbum?: (value: string) => void;
    onChangeAlbum?: (value: string) => void;
}

export const ModalConstructionProgressBody = memo(
    ({
        classes,
        isEdit,
        onDate,
        onDescription,
        formState,
        onAddNewAlbum,
        deleteSelectedAlbum,
        onChangeAlbum,
    }: ModalConstructionProgressBodyProps) => {
        const { currentProgress, t, albums, temporalAlbums } =
            useModalConstructionProgressBody(isEdit);
        return (
            <div className={cls.wrapper}>
                {isEdit && currentProgress && (
                    <div className={cls.imageWrapper}>
                        <img src={currentProgress.preview_url} alt={currentProgress.preview_url} />
                    </div>
                )}
                <form className={classNames(cls.ModalConstructionProgress, [classes])}>
                    <DateInput
                        date={moment(formState.date).format(
                            t('ModalConstructionProgressBody.return.dateInput.date.format')
                        )}
                        title={t('ModalConstructionProgressBody.return.dateInput.title')}
                        parameterName="date"
                        callback={onDate}
                        options={{
                            startDate: moment(formState.date).format(
                                t('ModalConstructionProgressBody.return.dateInput.date.format')
                            ),
                            autoUpdateInput: false,
                            singleDatePicker: true,
                            showDropdowns: true,
                            autoApply: true,
                        }}
                    />
                    <AlbumSelect
                        selected={formState.albums}
                        options={[...albums, ...temporalAlbums]}
                        onAddNewTag={onAddNewAlbum}
                        onChange={onChangeAlbum}
                        deleteHandle={deleteSelectedAlbum}
                    />
                    <TextArea
                        maxLength={255}
                        classes={cls.textArea}
                        inputName="description"
                        onChange={onDescription}
                        value={formState.description}
                        label={t('ModalConstructionProgressBody.return.textArea.label')}
                        placeholder={t('ModalConstructionProgressBody.return.textArea.placeholder')}
                    />
                </form>
            </div>
        );
    }
);
